import React, { createContext, useContext } from "react";
import { theme } from "../components/theme";

const partsData = [
  {
    id: 1,
    name: "8",
    timestamp: "03/11/2024",
    color: theme.colors.suspicious,
    type: "Suspicious",
    product: "85674809",
    petronoster: "05.36",
    factor1:"75%",
    factor2:"35%",
    factor3:"32%",
    factor4:"15%",
    factor5:"67%",
    factor6:"09%"
  },
  {
    id: 2,
    name: "34566786",
    timestamp: "04/21/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674809",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"42%",
    factor4:"15%",
    factor5:"67%",
    factor6:"09%"
  },
  {
    id: 3,
    name: "34566785",
    timestamp: "05/01/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674809",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"32%",
    factor4:"15%",
    factor5:"67%",
    factor6:"09%"
  },
  {
    id: 4,
    name: "34566784",
    timestamp: "04/29/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674809",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"32%",
    factor4:"75%",
    factor5:"67%",
    factor6:"09%"
  },
  {
    id: 5,
    name: "34566783",
    timestamp: "03/01/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674809",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"72%",
    factor4:"15%",
    factor5:"67%",
    factor6:"09%"
  },
  {
    id: 6,
    name: "34566782",
    timestamp: "03/01/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674809",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"32%",
    factor4:"15%",
    factor5:"37%",
    factor6:"09%"
  },
  {
    id: 7,
    name: "34566781",
    timestamp: "04/21/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674809",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"32%",
    factor4:"15%",
    factor5:"67%",
    factor6:"09%"
  },
  {
    id: 8,
    name: "34566780",
    timestamp: "05/01/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674810",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"72%",
    factor4:"15%",
    factor5:"67%",
    factor6:"09%"
  },
  {
    id: 9,
    name: "34566779",
    timestamp: "05/01/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674810",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"32%",
    factor4:"15%",
    factor6:"79%"
  },
  {
    id: 10,
    name: "34566778",
    timestamp: "04/03/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674810",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"32%",
    factor4:"15%",
    factor6:"09%"
  },
  {
    id: 11,
    name: "34566777",
    timestamp: "04/02/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674811",
    petronoster: "00.02",
    factor1:"85%",
    factor2:"35%",
    factor3:"32%",
    factor4:"15%",
    factor6:"09%"
  },
  {
    id: 12,
    name: "34566776",
    timestamp: "03/01/2024",
    color: theme.colors.good,
    type: "Good",
    product: "85674811",
    petronoster: "00.02",
    factor1:"25%",
    factor2:"35%",
    factor3:"32%",
    factor4:"15%",
    factor6:"09%"
  },
];

const productsData = [
  {
    productSystemId: 0,
    productCode: "Mercedes 294 ASHD",
    total_parts: 266,
    scrapped_parts: 0,
    good_parts: 266,
    percentageScrap: "0.0000",
  },
  {
    productSystemId: 1,
    productCode: "Mercedes678",
    total_parts: 224,
    scrapped_parts: 20,
    good_parts: 644,
    percentageScrap: "0.0000",
  },
  {
    productSystemId: 2,
    productCode: "Mercedes43",
    total_parts: 266,
    scrapped_parts: 0,
    good_parts: 266,
    percentageScrap: "0.0000",
  },
  {
    productSystemId: 3,
    productCode: "Mercedes56",
    total_parts: 466,
    scrapped_parts: 0,
    good_parts: 366,
    percentageScrap: "0.0000",
  },
  {
    productSystemId: 4,
    productCode: "Mercedes 296 ASHD ECE",
    total_parts: 95,
    scrapped_parts: 0,
    good_parts: 95,
    percentageScrap: "0.0000",
  },
];

const QualityDataContext = createContext();

export const QualityDataProvider = ({ children }) => {
  return (
    <QualityDataContext.Provider value={{ partsData, productsData }}>
      {children}
    </QualityDataContext.Provider>
  );
};

export const useQualityData = () => {
  return useContext(QualityDataContext);
};
